import { render } from "./HomeRestaurantsItem.vue?vue&type=template&id=689873ef&scoped=true"
import script from "./HomeRestaurantsItem.vue?vue&type=script&lang=js"
export * from "./HomeRestaurantsItem.vue?vue&type=script&lang=js"

import "./HomeRestaurantsItem.vue?vue&type=style&index=0&id=689873ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689873ef"]])

export default __exports__